module.exports = __webpack_public_path__ + "img/cloth_g3_hat_14.87fbbf5b.svg";